var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    staticClass: "splash-page splash-page-mobile splash-page--mobile splash-page--mobile-ge",
    on: {
      "click": _vm.backgroundClick
    }
  }, [_c('div', {
    ref: "partsCustomize",
    staticClass: "splash-page-modal-graphic-editor-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header') && _vm.isUgcApplied,
      expression: "verifyModuleVisibility('header') && isUgcApplied"
    }],
    class: ['splash-page__ge-zoom', 'splash-page__header-tools', _vm.regionIsApac ? 'splash-page__header-tools--apac' : '']
  }, [_c('img', {
    staticClass: "splash-page__arrow splash-page__arrow--tools",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-hand-zoom.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('scrollToZoom')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header'),
      expression: "verifyModuleVisibility('header')"
    }],
    class: ['splash-page__ge-customize', 'splash-page__header-tools', _vm.regionIsApac ? 'splash-page__header-tools--apac' : '']
  }, [_c('img', {
    staticClass: "splash-page__arrow splash-page__arrow--tools",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-hand-touch.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('tapGraphicCustomize')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('tabs') && _vm.isUgcApplied,
      expression: "verifyModuleVisibility('tabs') && isUgcApplied"
    }],
    staticClass: "splash-page__ge-drag-rep-img"
  }, [_c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-hand-direction.svg")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('dragRepositionImage')))])]), _c('modal-button-nav', {
    ref: "modalButtonNav",
    staticClass: "button-nav",
    attrs: {
      "cta-primary-button": _vm.skipToGetStartedTranslation,
      "show-icon-button": false,
      "show-cta-secondary-button": false,
      "show-cta-primary-button": true,
      "block-cta-primary-button": false
    },
    on: {
      "ctaPrimaryAction": _vm.onSkip
    }
  })], 1), _c('div', {
    staticClass: "splash-page__ge-done"
  }, [_c('label', {
    staticClass: "splash-page_ge-done-button"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.apparel.graphicZoomOut) + "\n    ")]), _c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/add-your-own-arrow-step2.png")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('tapDone')))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }